import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { SHAPE } from "../../common/component/constants";

export default function ProductShapeAutocomplete(props) {
  const { productType, value } = props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (productType === "Cake") {
      setOptions(SHAPE);
    } else {
      setOptions(["Custom"]);
    }
  }, [productType]);

  const onChange = (e, v) => {
    props.onChange(v);
  };

  return (
    <Autocomplete
      value={value}
      onChange={onChange}
      onInputChange={onChange}
      options={options}
      renderInput={(params) => <TextField required={props.required} variant="outlined" {...params} label={props.label} />}
      disableClearable
      freeSolo
      blurOnSelect={true}
    />
  );
}
